import SigliveServiceSSE from 'Service/sigliveServiceSSE';

const getProductHighlightList = async (queries = '') => {
  const { data } = await SigliveServiceSSE({ method: 'GET', url: `/briefs/product-variant/list?${queries}` });

  return data;
};

export default getProductHighlightList;
